export default "__VITE_ASSET__Bx3wyu2p__"